// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-report {
  min-height: calc(100vh - 50px);
  padding: 18px;
  background: #f3f6fa;
  color: #172b4d;
}

.summary-report__hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 18px 22px;
  border: 1px solid #dce5f0;
  border-radius: 12px 12px 0 0;
  background: linear-gradient(110deg, #ffffff 0%, #f5f9ff 100%);
}

.summary-report__eyebrow {
  margin-bottom: 4px;
  color: #0b66d4;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.summary-report__hero h1 {
  margin: 0;
  color: #102a4c;
  font-size: 25px;
  font-weight: 750;
}

.summary-report__hero p {
  margin: 4px 0 0;
  color: #65758b;
  font-size: 14px;
}

.summary-report__hero-metrics {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.summary-report__hero-metrics > div {
  display: flex;
  min-width: 110px;
  flex-direction: column;
  justify-content: center;
  padding: 9px 13px;
  border: 1px solid #dce6f2;
  border-radius: 8px;
  background: #ffffff;
}

.summary-report__hero-metrics span {
  color: #718198;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.summary-report__hero-metrics strong {
  margin-top: 2px;
  color: #0b4f9c;
  font-size: 19px;
}

.summary-report__toolbar {
  display: grid;
  grid-template-columns: auto 190px minmax(560px, 1fr) auto;
  align-items: end;
  gap: 14px;
  padding: 14px 18px;
  border-right: 1px solid #dce5f0;
  border-bottom: 1px solid #dce5f0;
  border-left: 1px solid #dce5f0;
  background: #ffffff;
}

.summary-report__status-switch {
  display: flex;
  padding: 3px;
  border: 1px solid #d6e0ec;
  border-radius: 8px;
  background: #f2f5f9;
}

.summary-report__status-switch button {
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 42px;
  padding: 0 15px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #52647b;
  font-size: 13px;
  font-weight: 700;
}

.summary-report__status-switch button.is-active {
  background: #ffffff;
  color: #0b4f9c;
  box-shadow: 0 1px 4px rgba(20, 47, 82, 0.14);
}

.summary-report__status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #8a99ad;
}

.summary-report__status-dot--InProgress {
  background: #f3a712;
}

.summary-report__status-dot--Completed {
  background: #20a05a;
}

.summary-report__field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
}

.summary-report__field > span,
.summary-report__filters label > span {
  color: #5d6f86;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.summary-report__field input,
.summary-report__filters input {
  height: 42px;
  border: 1px solid #cdd9e7;
  border-radius: 7px;
  background: #ffffff;
  width: 100%;
  padding: 0 11px;
  outline: none;
  color: #233b5d;
  font-size: 13px;
}

.summary-report__field input:focus,
.summary-report__filters input:focus {
  border-color: #2d78c4;
  box-shadow: 0 0 0 3px rgba(45, 120, 196, 0.12);
}

.summary-report__field.is-disabled {
  opacity: 0.48;
}

.summary-report__filters {
  display: grid;
  min-width: 0;
  grid-template-columns: repeat(3, minmax(145px, 1fr)) auto auto;
  align-items: end;
  gap: 8px;
}

.summary-report__filters label {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
}

.summary-report__filter-apply,
.summary-report__filter-clear {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 14px;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 750;
}

.summary-report__filter-apply {
  border: 0;
  background: #0b66d4;
  color: #ffffff;
}

.summary-report__filter-clear {
  border: 1px solid #cbd7e5;
  background: #ffffff;
  color: #4a607b;
}

.summary-report__download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 17px;
  border: 0;
  border-radius: 7px;
  background: #08783e;
  color: #ffffff;
  font-size: 13px;
  font-weight: 750;
  box-shadow: 0 3px 9px rgba(8, 120, 62, 0.2);
}

.summary-report__download:hover:not(:disabled) {
  background: #066934;
}

.summary-report__download:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.summary-report__content {
  margin-top: 14px;
  overflow: hidden;
  border: 1px solid #d8e2ee;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(25, 55, 93, 0.05);
}

.summary-report__table-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-bottom: 1px solid #e1e8f1;
}

.summary-report__table-heading h2 {
  margin: 0;
  color: #183558;
  font-size: 18px;
  font-weight: 750;
}

.summary-report__table-heading p {
  margin: 3px 0 0;
  color: #718198;
  font-size: 13px;
}

.summary-report__scroll-hint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #60758f;
  font-size: 12px;
}

.summary-report__table-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.summary-report__mode-switch {
  display: inline-flex;
  padding: 3px;
  border: 1px solid #ccd9e7;
  border-radius: 8px;
  background: #edf2f7;
}

.summary-report__mode-switch button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #536a84;
  font-size: 12px;
  font-weight: 750;
}

.summary-report__mode-switch button.is-active {
  background: #0b5eaa;
  color: #ffffff;
  box-shadow: 0 2px 5px rgba(11, 94, 170, 0.2);
}

.summary-report__table-shell {
  position: relative;
  min-height: 190px;
  max-height: calc(100vh - 335px);
  overflow: auto;
  scrollbar-color: #9eb2ca #edf2f7;
  scrollbar-width: thin;
}

.summary-report__table {
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  font-size: 13px;
}

.summary-report__table th,
.summary-report__table td {
  border-right: 1px solid #dae3ee;
  border-bottom: 1px solid #dae3ee;
}

.summary-report__table thead th {
  position: sticky;
  z-index: 5;
  text-align: center;
}

.summary-report__table thead tr:first-child th {
  top: 0;
  height: 58px;
}

.summary-report__table thead tr:nth-child(2) th {
  top: 58px;
  height: 44px;
}

.summary-report__department-group {
  min-width: 610px;
  padding: 9px 12px;
  background: #174f78;
  color: #ffffff;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.18);
}

.summary-report--detailed .summary-report__department-group {
  min-width: 1045px;
}

.summary-report__department-group.is-alternate {
  background: #255f88;
}

.summary-report__department-group span,
.summary-report__department-group strong {
  display: block;
}

.summary-report__department-group span {
  color: #d9efff;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.08em;
}

.summary-report__department-group strong {
  margin-top: 3px;
  color: #ffffff;
  font-size: 13px;
}

.summary-report__subhead {
  width: 115px;
  min-width: 115px;
  padding: 8px;
  background: #d8e8f6;
  color: #143a5d;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.025em;
  text-transform: uppercase;
}

.summary-report__subhead.is-alternate {
  background: #cfdfed;
}

.summary-report__subhead--date {
  width: 150px;
  min-width: 150px;
}

.summary-report--detailed .summary-report__subhead--consumption,
.summary-report--detailed .summary-report__subhead--reject,
.summary-report--detailed .summary-report__subhead--rework,
.summary-report--detailed .summary-report__value--consumption,
.summary-report--detailed .summary-report__value--reject,
.summary-report--detailed .summary-report__value--rework {
  width: 260px;
  min-width: 260px;
}

.summary-report__sticky {
  position: sticky !important;
  z-index: 4;
  background: #ffffff;
  text-align: left !important;
  box-shadow: 1px 0 0 #d2dce8;
}

.summary-report__table thead .summary-report__sticky {
  z-index: 8;
  padding: 0 12px;
  background: #123b60;
  color: #ffffff;
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.summary-report__sticky--size {
  left: 0;
  width: 205px;
  min-width: 205px;
  max-width: 205px;
}

.summary-report__sticky--customer {
  left: 205px;
  width: 245px;
  min-width: 245px;
  max-width: 245px;
}

.summary-report__sticky--jobcard {
  left: 450px;
  width: 175px;
  min-width: 175px;
  max-width: 175px;
  box-shadow: 4px 0 7px -5px #415a77;
}

.summary-report__table tbody tr:hover td,
.summary-report__table tbody tr:hover .summary-report__sticky {
  background: #f5f9ff;
}

.summary-report__table tbody .summary-report__sticky {
  height: 58px;
  padding: 9px 11px;
}

.summary-report__table tbody .summary-report__sticky strong,
.summary-report__table tbody .summary-report__sticky > span:not(.summary-report__jobcard) {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-report__table tbody .summary-report__sticky strong {
  color: #1c385a;
  font-size: 12px;
}

.summary-report__table tbody .summary-report__sticky > span:not(.summary-report__jobcard) {
  margin-top: 2px;
  color: #7a899d;
  font-size: 11px;
}

.summary-report__jobcard {
  display: inline-flex;
  padding: 5px 10px;
  border-radius: 999px;
  background: #e4ecf9;
  color: #173f78;
  font-size: 12px;
  font-weight: 800;
}

.summary-report__value {
  width: 115px;
  min-width: 115px;
  padding: 8px;
  background: #ffffff;
  text-align: center;
}

.summary-report__value--date {
  width: 150px;
  min-width: 150px;
}

.summary-report__quantity {
  display: inline-flex;
  min-width: 58px;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 5px;
  font-weight: 750;
}

.summary-report__quantity--consumption {
  background: #e8f1ff;
  color: #0759c7;
}

.summary-report__quantity--ok {
  background: #e3f5e9;
  color: #14733b;
}

.summary-report__quantity--reject {
  background: #ffebe9;
  color: #b42318;
}

.summary-report__quantity--rework {
  background: #fff2d5;
  color: #946200;
}

.summary-report__quantity--zero {
  background: transparent;
  color: #a7b2c0;
  font-weight: 500;
}

.summary-report__reason-breakdown {
  display: flex;
  min-height: 42px;
  align-items: center;
  flex-direction: column;
  gap: 7px;
}

.summary-report__reason-breakdown ul {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.summary-report__reason-breakdown li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 5px 6px;
  border-top: 1px solid #e3eaf2;
  color: #425b78;
  text-align: left;
}

.summary-report__reason-breakdown li span {
  overflow: hidden;
  flex: 1 1;
  font-size: 11px;
  font-weight: 650;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-report__reason-breakdown li strong {
  display: inline-flex;
  min-width: 38px;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 999px;
  background: #eef3f8;
  color: #183b61;
  font-size: 11px;
}

.summary-report__consumption-breakdown li span {
  display: flex;
  flex-direction: column;
  white-space: normal;
}

.summary-report__consumption-breakdown li small {
  margin-top: 2px;
  color: #718198;
  font-size: 10px;
  font-weight: 600;
}

.summary-report--detailed .summary-report__table tbody .summary-report__sticky {
  height: auto;
  vertical-align: top;
}

.summary-report__date {
  color: #314d6f;
  font-size: 12px;
  font-weight: 650;
  white-space: nowrap;
}

.summary-report__empty {
  color: #b2bdca;
}

.summary-report__empty-state {
  display: flex;
  min-height: 190px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
  color: #738399;
}

.summary-report__empty-state i {
  color: #aab8c8;
  font-size: 25px;
}

.summary-report__empty-state strong {
  color: #435b78;
  font-size: 13px;
}

.summary-report__empty-state span {
  font-size: 13px;
}

.summary-report__pagination {
  display: flex;
  min-height: 52px;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  padding: 8px 14px;
  border-top: 1px solid #dce5ef;
  color: #62758e;
  font-size: 13px;
}

.summary-report__pagination label {
  display: flex;
  align-items: center;
  gap: 7px;
}

.summary-report__pagination select {
  height: 30px;
  border: 1px solid #ced9e6;
  border-radius: 5px;
  background: #ffffff;
  color: #344d6d;
}

.summary-report__page-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.summary-report__page-controls span {
  padding: 0 9px;
}

.summary-report__page-controls button {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d3deea;
  border-radius: 5px;
  background: #ffffff;
  color: #335275;
}

.summary-report__page-controls button:disabled {
  color: #bdc6d1;
  cursor: not-allowed;
}

@media (max-width: 1100px) {
  .summary-report__hero {
    align-items: flex-start;
    flex-direction: column;
  }
  .summary-report__toolbar {
    grid-template-columns: 1fr 1fr;
  }
  .summary-report__filters {
    grid-column: 1/-1;
  }
  .summary-report__table-heading {
    align-items: flex-start;
  }
  .summary-report__table-actions {
    align-items: flex-end;
    flex-direction: column;
  }
}
@media (max-width: 700px) {
  .summary-report {
    padding: 8px;
  }
  .summary-report__hero-metrics {
    width: 100%;
    overflow-x: auto;
  }
  .summary-report__toolbar {
    grid-template-columns: 1fr;
  }
  .summary-report__filters {
    grid-column: auto;
    grid-template-columns: 1fr;
  }
  .summary-report__pagination {
    align-items: flex-end;
    flex-direction: column;
    gap: 8px;
  }
  .summary-report__table-heading,
  .summary-report__table-actions {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/reports/SummaryReport.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,4BAAA;EACA,6DAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,oBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,yDAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;;EAEE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EAKA,WAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AARF;;AAWA;;EAEE,qBAAA;EACA,8CAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,8DAAA;EACA,gBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;;EAEE,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,oBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,cAAA;EACA,gCAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,+BAAA;EACA,gCAAA;AACF;;AAEA;EACE,gBAAA;EACA,UAAA;EACA,kBAAA;AACF;;AAEA;EACE,MAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,0CAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;;EAEE,cAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;;;;;;EAME,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,2BAAA;EACA,UAAA;EACA,mBAAA;EACA,2BAAA;EACA,2BAAA;AACF;;AAEA;EACE,UAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACE,uBAAA;IACA,sBAAA;EACF;EAEA;IACE,8BAAA;EAAF;EAGA;IACE,iBAAA;EADF;EAIA;IACE,uBAAA;EAFF;EAKA;IACE,qBAAA;IACA,sBAAA;EAHF;AACF;AAMA;EACE;IACE,YAAA;EAJF;EAOA;IACE,WAAA;IACA,gBAAA;EALF;EAQA;IACE,0BAAA;EANF;EASA;IACE,iBAAA;IACA,0BAAA;EAPF;EAUA;IACE,qBAAA;IACA,sBAAA;IACA,QAAA;EARF;EAWA;;IAEE,WAAA;IACA,sBAAA;IACA,uBAAA;EATF;AACF","sourcesContent":[".summary-report {\n  min-height: calc(100vh - 50px);\n  padding: 18px;\n  background: #f3f6fa;\n  color: #172b4d;\n}\n\n.summary-report__hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 18px 22px;\n  border: 1px solid #dce5f0;\n  border-radius: 12px 12px 0 0;\n  background: linear-gradient(110deg, #ffffff 0%, #f5f9ff 100%);\n}\n\n.summary-report__eyebrow {\n  margin-bottom: 4px;\n  color: #0b66d4;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.summary-report__hero h1 {\n  margin: 0;\n  color: #102a4c;\n  font-size: 25px;\n  font-weight: 750;\n}\n\n.summary-report__hero p {\n  margin: 4px 0 0;\n  color: #65758b;\n  font-size: 14px;\n}\n\n.summary-report__hero-metrics {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n}\n\n.summary-report__hero-metrics > div {\n  display: flex;\n  min-width: 110px;\n  flex-direction: column;\n  justify-content: center;\n  padding: 9px 13px;\n  border: 1px solid #dce6f2;\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.summary-report__hero-metrics span {\n  color: #718198;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.summary-report__hero-metrics strong {\n  margin-top: 2px;\n  color: #0b4f9c;\n  font-size: 19px;\n}\n\n.summary-report__toolbar {\n  display: grid;\n  grid-template-columns: auto 190px minmax(560px, 1fr) auto;\n  align-items: end;\n  gap: 14px;\n  padding: 14px 18px;\n  border-right: 1px solid #dce5f0;\n  border-bottom: 1px solid #dce5f0;\n  border-left: 1px solid #dce5f0;\n  background: #ffffff;\n}\n\n.summary-report__status-switch {\n  display: flex;\n  padding: 3px;\n  border: 1px solid #d6e0ec;\n  border-radius: 8px;\n  background: #f2f5f9;\n}\n\n.summary-report__status-switch button {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  min-height: 42px;\n  padding: 0 15px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #52647b;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.summary-report__status-switch button.is-active {\n  background: #ffffff;\n  color: #0b4f9c;\n  box-shadow: 0 1px 4px rgba(20, 47, 82, 0.14);\n}\n\n.summary-report__status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #8a99ad;\n}\n\n.summary-report__status-dot--InProgress {\n  background: #f3a712;\n}\n\n.summary-report__status-dot--Completed {\n  background: #20a05a;\n}\n\n.summary-report__field {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.summary-report__field > span,\n.summary-report__filters label > span {\n  color: #5d6f86;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.summary-report__field input,\n.summary-report__filters input {\n  height: 42px;\n  border: 1px solid #cdd9e7;\n  border-radius: 7px;\n  background: #ffffff;\n}\n\n.summary-report__field input,\n.summary-report__filters input {\n  width: 100%;\n  padding: 0 11px;\n  outline: none;\n  color: #233b5d;\n  font-size: 13px;\n}\n\n.summary-report__field input:focus,\n.summary-report__filters input:focus {\n  border-color: #2d78c4;\n  box-shadow: 0 0 0 3px rgba(45, 120, 196, 0.12);\n}\n\n.summary-report__field.is-disabled {\n  opacity: 0.48;\n}\n\n.summary-report__filters {\n  display: grid;\n  min-width: 0;\n  grid-template-columns: repeat(3, minmax(145px, 1fr)) auto auto;\n  align-items: end;\n  gap: 8px;\n}\n\n.summary-report__filters label {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.summary-report__filter-apply,\n.summary-report__filter-clear {\n  display: inline-flex;\n  min-height: 42px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 14px;\n  border-radius: 7px;\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.summary-report__filter-apply {\n  border: 0;\n  background: #0b66d4;\n  color: #ffffff;\n}\n\n.summary-report__filter-clear {\n  border: 1px solid #cbd7e5;\n  background: #ffffff;\n  color: #4a607b;\n}\n\n.summary-report__download {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 0 17px;\n  border: 0;\n  border-radius: 7px;\n  background: #08783e;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 750;\n  box-shadow: 0 3px 9px rgba(8, 120, 62, 0.2);\n}\n\n.summary-report__download:hover:not(:disabled) {\n  background: #066934;\n}\n\n.summary-report__download:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.summary-report__content {\n  margin-top: 14px;\n  overflow: hidden;\n  border: 1px solid #d8e2ee;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 0 4px 14px rgba(25, 55, 93, 0.05);\n}\n\n.summary-report__table-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #e1e8f1;\n}\n\n.summary-report__table-heading h2 {\n  margin: 0;\n  color: #183558;\n  font-size: 18px;\n  font-weight: 750;\n}\n\n.summary-report__table-heading p {\n  margin: 3px 0 0;\n  color: #718198;\n  font-size: 13px;\n}\n\n.summary-report__scroll-hint {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #60758f;\n  font-size: 12px;\n}\n\n.summary-report__table-actions {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.summary-report__mode-switch {\n  display: inline-flex;\n  padding: 3px;\n  border: 1px solid #ccd9e7;\n  border-radius: 8px;\n  background: #edf2f7;\n}\n\n.summary-report__mode-switch button {\n  display: inline-flex;\n  min-height: 34px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #536a84;\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.summary-report__mode-switch button.is-active {\n  background: #0b5eaa;\n  color: #ffffff;\n  box-shadow: 0 2px 5px rgba(11, 94, 170, 0.2);\n}\n\n.summary-report__table-shell {\n  position: relative;\n  min-height: 190px;\n  max-height: calc(100vh - 335px);\n  overflow: auto;\n  scrollbar-color: #9eb2ca #edf2f7;\n  scrollbar-width: thin;\n}\n\n.summary-report__table {\n  width: max-content;\n  min-width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  table-layout: fixed;\n  font-size: 13px;\n}\n\n.summary-report__table th,\n.summary-report__table td {\n  border-right: 1px solid #dae3ee;\n  border-bottom: 1px solid #dae3ee;\n}\n\n.summary-report__table thead th {\n  position: sticky;\n  z-index: 5;\n  text-align: center;\n}\n\n.summary-report__table thead tr:first-child th {\n  top: 0;\n  height: 58px;\n}\n\n.summary-report__table thead tr:nth-child(2) th {\n  top: 58px;\n  height: 44px;\n}\n\n.summary-report__department-group {\n  min-width: 610px;\n  padding: 9px 12px;\n  background: #174f78;\n  color: #ffffff;\n  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.18);\n}\n\n.summary-report--detailed .summary-report__department-group {\n  min-width: 1045px;\n}\n\n.summary-report__department-group.is-alternate {\n  background: #255f88;\n}\n\n.summary-report__department-group span,\n.summary-report__department-group strong {\n  display: block;\n}\n\n.summary-report__department-group span {\n  color: #d9efff;\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n}\n\n.summary-report__department-group strong {\n  margin-top: 3px;\n  color: #ffffff;\n  font-size: 13px;\n}\n\n.summary-report__subhead {\n  width: 115px;\n  min-width: 115px;\n  padding: 8px;\n  background: #d8e8f6;\n  color: #143a5d;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.025em;\n  text-transform: uppercase;\n}\n\n.summary-report__subhead.is-alternate {\n  background: #cfdfed;\n}\n\n.summary-report__subhead--date {\n  width: 150px;\n  min-width: 150px;\n}\n\n.summary-report--detailed .summary-report__subhead--consumption,\n.summary-report--detailed .summary-report__subhead--reject,\n.summary-report--detailed .summary-report__subhead--rework,\n.summary-report--detailed .summary-report__value--consumption,\n.summary-report--detailed .summary-report__value--reject,\n.summary-report--detailed .summary-report__value--rework {\n  width: 260px;\n  min-width: 260px;\n}\n\n.summary-report__sticky {\n  position: sticky !important;\n  z-index: 4;\n  background: #ffffff;\n  text-align: left !important;\n  box-shadow: 1px 0 0 #d2dce8;\n}\n\n.summary-report__table thead .summary-report__sticky {\n  z-index: 8;\n  padding: 0 12px;\n  background: #123b60;\n  color: #ffffff;\n  font-size: 12px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.summary-report__sticky--size {\n  left: 0;\n  width: 205px;\n  min-width: 205px;\n  max-width: 205px;\n}\n\n.summary-report__sticky--customer {\n  left: 205px;\n  width: 245px;\n  min-width: 245px;\n  max-width: 245px;\n}\n\n.summary-report__sticky--jobcard {\n  left: 450px;\n  width: 175px;\n  min-width: 175px;\n  max-width: 175px;\n  box-shadow: 4px 0 7px -5px #415a77;\n}\n\n.summary-report__table tbody tr:hover td,\n.summary-report__table tbody tr:hover .summary-report__sticky {\n  background: #f5f9ff;\n}\n\n.summary-report__table tbody .summary-report__sticky {\n  height: 58px;\n  padding: 9px 11px;\n}\n\n.summary-report__table tbody .summary-report__sticky strong,\n.summary-report__table tbody .summary-report__sticky > span:not(.summary-report__jobcard) {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.summary-report__table tbody .summary-report__sticky strong {\n  color: #1c385a;\n  font-size: 12px;\n}\n\n.summary-report__table tbody .summary-report__sticky > span:not(.summary-report__jobcard) {\n  margin-top: 2px;\n  color: #7a899d;\n  font-size: 11px;\n}\n\n.summary-report__jobcard {\n  display: inline-flex;\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: #e4ecf9;\n  color: #173f78;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.summary-report__value {\n  width: 115px;\n  min-width: 115px;\n  padding: 8px;\n  background: #ffffff;\n  text-align: center;\n}\n\n.summary-report__value--date {\n  width: 150px;\n  min-width: 150px;\n}\n\n.summary-report__quantity {\n  display: inline-flex;\n  min-width: 58px;\n  justify-content: center;\n  padding: 4px 8px;\n  border-radius: 5px;\n  font-weight: 750;\n}\n\n.summary-report__quantity--consumption {\n  background: #e8f1ff;\n  color: #0759c7;\n}\n\n.summary-report__quantity--ok {\n  background: #e3f5e9;\n  color: #14733b;\n}\n\n.summary-report__quantity--reject {\n  background: #ffebe9;\n  color: #b42318;\n}\n\n.summary-report__quantity--rework {\n  background: #fff2d5;\n  color: #946200;\n}\n\n.summary-report__quantity--zero {\n  background: transparent;\n  color: #a7b2c0;\n  font-weight: 500;\n}\n\n.summary-report__reason-breakdown {\n  display: flex;\n  min-height: 42px;\n  align-items: center;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.summary-report__reason-breakdown ul {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.summary-report__reason-breakdown li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 5px 6px;\n  border-top: 1px solid #e3eaf2;\n  color: #425b78;\n  text-align: left;\n}\n\n.summary-report__reason-breakdown li span {\n  overflow: hidden;\n  flex: 1;\n  font-size: 11px;\n  font-weight: 650;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.summary-report__reason-breakdown li strong {\n  display: inline-flex;\n  min-width: 38px;\n  justify-content: center;\n  padding: 2px 6px;\n  border-radius: 999px;\n  background: #eef3f8;\n  color: #183b61;\n  font-size: 11px;\n}\n\n.summary-report__consumption-breakdown li span {\n  display: flex;\n  flex-direction: column;\n  white-space: normal;\n}\n\n.summary-report__consumption-breakdown li small {\n  margin-top: 2px;\n  color: #718198;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.summary-report--detailed .summary-report__table tbody .summary-report__sticky {\n  height: auto;\n  vertical-align: top;\n}\n\n.summary-report__date {\n  color: #314d6f;\n  font-size: 12px;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.summary-report__empty {\n  color: #b2bdca;\n}\n\n.summary-report__empty-state {\n  display: flex;\n  min-height: 190px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 5px;\n  color: #738399;\n}\n\n.summary-report__empty-state i {\n  color: #aab8c8;\n  font-size: 25px;\n}\n\n.summary-report__empty-state strong {\n  color: #435b78;\n  font-size: 13px;\n}\n\n.summary-report__empty-state span {\n  font-size: 13px;\n}\n\n.summary-report__pagination {\n  display: flex;\n  min-height: 52px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 24px;\n  padding: 8px 14px;\n  border-top: 1px solid #dce5ef;\n  color: #62758e;\n  font-size: 13px;\n}\n\n.summary-report__pagination label {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.summary-report__pagination select {\n  height: 30px;\n  border: 1px solid #ced9e6;\n  border-radius: 5px;\n  background: #ffffff;\n  color: #344d6d;\n}\n\n.summary-report__page-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.summary-report__page-controls span {\n  padding: 0 9px;\n}\n\n.summary-report__page-controls button {\n  display: inline-flex;\n  width: 30px;\n  height: 30px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #d3deea;\n  border-radius: 5px;\n  background: #ffffff;\n  color: #335275;\n}\n\n.summary-report__page-controls button:disabled {\n  color: #bdc6d1;\n  cursor: not-allowed;\n}\n\n@media (max-width: 1100px) {\n  .summary-report__hero {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .summary-report__toolbar {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .summary-report__filters {\n    grid-column: 1 / -1;\n  }\n\n  .summary-report__table-heading {\n    align-items: flex-start;\n  }\n\n  .summary-report__table-actions {\n    align-items: flex-end;\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 700px) {\n  .summary-report {\n    padding: 8px;\n  }\n\n  .summary-report__hero-metrics {\n    width: 100%;\n    overflow-x: auto;\n  }\n\n  .summary-report__toolbar {\n    grid-template-columns: 1fr;\n  }\n\n  .summary-report__filters {\n    grid-column: auto;\n    grid-template-columns: 1fr;\n  }\n\n  .summary-report__pagination {\n    align-items: flex-end;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .summary-report__table-heading,\n  .summary-report__table-actions {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
